/***************************************************
Alexander Self
12/01/18
MechanicalHarvestReducer: Handles harvest related actions
****************************************************/
import { 
  FETCH_FIELDS_BY_LOC, 
  FETCH_BLOCKS_BY_FIELD, 
  SELECT_FIELD, 
  CREATE_MECH_HARVEST,
  FETCH_MECH_HARVEST, 
  PREPARE_MECH_HARVEST_TO_CREATE,
  PREPARE_MECH_HARVEST_TO_CREATE_2, 
  PREPARE_MECH_HARVEST_TO_EDIT,
  SET_REPORT_OPTS,
  SELECT_REPORT_TYPE, 
  SELECT_NEW_REPORT, 
  FETCH_REPORT, 
  FETCH_MY_MECH_HARVEST,
  SELECT_HARVEST_TO_MANAGE, 
  RESET_MANAGE_HARVEST, 
  FETCH_HARVEST_BY_DATE, 
  EDIT_MECH_HARVEST,
  DELETE_MECH_HARVEST, 
  ERROR,
  ADD_HARVEST_RECORD,
  SET_MECH_HARVEST_TO_EDIT,
  EDIT_MECH_HARVEST_RECORD,
  DELETE_MECH_HARVEST_RECORD 
} from '../actions/types';
const initState = {
  harvest: {
    mech: {
      all: [],
      displaying: []
    },
    hand: {
      all: [],
      displaying: []
    }
  },
  create: {
    selectedField: {},
    harvest: {},
    previousHarvest: [],
    harvestRecords: [],
    harvestToEdit: {},
    toEdit: false
  },
  manage: {
    editedHarvest: {}, // New harvest which was edited
    selectedField: {},
    selectedHarvest: {},
    previousHarvest: [],
    myHarvest: [], // Initial pull is for all harvest records that were submitted by a user
    isEditOrDelete: false // Determines if the edit and delete options will be present
  },
  report: {
    disabled: '', // Disables form options for report: Limits query
    options: {},
    reportOpts: {
      reportRunning: false, // Switches UI for larger screen on report
      employee: false, // Determines if an employee was queried
      equipment: false, // Determines if an equipment was queried
      field: false
    },
    query: {
      data: [],
      summary: {},
      type: ''
    }
  },
  equipmentNo: [], // Equipment no's with descriptions
  seasons: [], // current farming seaons
  employees: {
    displaying: [],
    all: []
  }, // List of current employees
  fields: [],
  blocks: []
};

export default function HarvestReducer(state=initState, action) {
  switch (action.type) {
    case FETCH_MECH_HARVEST:
      return { ...state,
        harvest: { ...state.harvest,
          mech: {
            all: action.mechHarvest,
            displaying: action.mechHarvest.sort(sortByDate)
          }
        },
        equipmentNo: action.equipmentNo,
        seasons: action.seasons,
        fields: action.fields,
        employees: {
          all: action.employees,
          displaying: action.employees.filter((e) => e.employeeStatus === 'Active')
        }
      };
    case CREATE_MECH_HARVEST:
      return { ...state,
        create: initState.create
      };
    case FETCH_FIELDS_BY_LOC:
      return { ...state,
        fields: action.payload
      };
    case FETCH_BLOCKS_BY_FIELD:
      return { ...state,
        blocks: action.payload
      };
    case SELECT_FIELD:
      return { ...state,
        create: { ...state.create,
          selectedField: state.fields.find((f) => f.field === action.payload)
        }
      };
    case PREPARE_MECH_HARVEST_TO_CREATE:
      return { ...state,
        create: { ...state.create,
          harvest: action.payload,
          selectedField: action.selectedField,
          previousHarvest: action.previousHarvest
        }
      };
    case PREPARE_MECH_HARVEST_TO_CREATE_2:
      return { ...state,
        create: { ...state.create,
          harvestRecords: action.payload,
          previousHarvest: action.previousHarvest
        }
      }
    case PREPARE_MECH_HARVEST_TO_EDIT:
      return { ...state,
        manage: { ...state.manage,
          editedHarvest: action.payload,
          selectedField: action.selectedField,
          previousHarvest: action.previousHarvest
        }
      };
    case SELECT_REPORT_TYPE:
      return { ...state,
        report: { ...state.report,
          disabled: action.payload
        }
      };
    case SET_REPORT_OPTS:
      let employee = state.report.reportOpts.employee;
      let equipment = state.report.reportOpts.equipment;
      let field = state.report.reportOpts.field;
      if (action.payload.eid) employee = !state.report.reportOpts.employee;
      if (action.payload.equipmentNo) equipment = !state.report.reportOpts.equipment;
      if (action.payload.field) field = !state.report.reportOpts.field;
      return { ...state,
        report: { ...state.report,
          reportOpts: { ...state.report.reportOpts,
            reportRunning: !state.report.reportOpts.reportRunning,
            employee,
            equipment,
            field
          }
        }
      }
    case SELECT_NEW_REPORT:
      return { ...state,
        report: {
          disabled: '',
          options: {},
          reportOpts: {
            reportRunning: false,
            employee: false,
            equipment: false,
            field: false
          },
          query: {
            data: [],
            summary: {},
            type: ''
          }
        }
      };
    case FETCH_REPORT:
      return { ...state,
        report: { ...state.report,
          options: action.options,
          query: action.payload
        }
      };
    case FETCH_MY_MECH_HARVEST:
      return { ...state,
        manage: { ...state.manage,
          myHarvest: state.harvest.mech.all.filter((h) => h.submitter === action.payload).sort(sortByDate)
        }
      };
    case SELECT_HARVEST_TO_MANAGE:
      return { ...state,
        manage: { ...state.manage,
          editedHarvest: {},
          selectedHarvest: action.payload,
          selectedField: action.selectedField,
          isEditOrDelete: true
        },
        blocks: action.blocks
      };
    case RESET_MANAGE_HARVEST:
      return { ...state,
        manage: { ...state.manage,
          editedHarvest: {},
          selectedField: {},
          selectedHarvest: {},
          previousHarvest: [],
          isEditOrDelete: !state.manage.isEditOrDelete
        }
      };
    case FETCH_HARVEST_BY_DATE:
      let _harvest = action.payload;
      if (_harvest.length > 0) _harvest = _harvest.sort(sortByDate);
      return { ...state,
        manage: { ...state.manage,
          myHarvest: _harvest
        }
      };
    case EDIT_MECH_HARVEST:
      return { ...state,
        harvest: { ...state.harvest,
          mech: { ...state.harvest.mech,
            all: state.harvest.mech.all.filter((h) => h.id !== action.payload.id).concat(action.payload).sort(sortByDate),
            displaying: state.harvest.mech.displaying.filter((h) => h.id !== action.payload.id).concat(action.payload).sort(sortByDate)
          }
        },
        manage: {
          myHarvest: state.manage.myHarvest.filter((h) => h.id !== action.payload.id).concat(action.payload).filter((h) => h.submitter === action.submitter).sort(sortByDate),
          editedHarvest: {},
          selectedField: {},
          selectedHarvest: {},
          previousHarvest: [],
          isEditOrDelete: false
        }
      };
    case DELETE_MECH_HARVEST:
      return { ...state,
        harvest: { ...state.harvest,
          mech: { ...state.harvest.mech,
            all: state.harvest.mech.all.filter((h) => h.id !== action.payload).sort(sortByDate),
            displaying: state.harvest.mech.displaying.filter((h) => h.id !== action.payload).sort(sortByDate)
          }
        },
        manage: {
          myHarvest: state.manage.myHarvest.filter((h) => h.id !== action.payload).filter((h) => h.submitter === action.submitter).sort(sortByDate),
          editedHarvest: {},
          selectedField: {},
          selectedHarvest: {},
          previousHarvest: [],
          isEditOrDelete: false
        }
      };
    case ERROR:
      return { ...state,
        report: {
          disabled: '',
          reportOpts: {
            reportRunning: false,
            employee: false,
            equipment: false,
            field: false
          },
          query: {
            data: [],
            summary: {},
            type: ''
          }
        }
      };
    case ADD_HARVEST_RECORD:
      return { ...state,
        create: { ...state.create,
          harvestRecords: state.create.harvestRecords.concat(action.payload)
        }
      }
    case SET_MECH_HARVEST_TO_EDIT:
      return { ...state,
        create: { ...state.create,
          harvestToEdit: action.payload,
          toEdit: true
        }
      }
    case EDIT_MECH_HARVEST_RECORD:
      return { ...state,
        create: { ...state.create,
          harvestToEdit: initState.create.harvestToEdit,
          toEdit: false,
          harvestRecords: state.create.harvestRecords
                            .filter((h) => h.guid !== state.create.harvestToEdit.guid)
                            .concat({ 
                              ...action.payload, 
                              guid: state.create.harvestToEdit.guid
                            })
        }
      }
    case DELETE_MECH_HARVEST_RECORD:
      return { ...state,
        create: { ...state.create,
          harvestRecords: state.create.harvestRecords.filter((h) => h.guid !== action.payload)
        }
      }
    default:
      return state;
  }
}


function sortByDate(a,b) {
  if (new Date(a.date) < new Date(b.date)) return 1;
  else if (new Date(a.date) > new Date(b.date)) return -1;
  return 0;
}
















/* END */



// WEBPACK FOOTER //
// ./src/reducers/harvest_reducer.js